import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, switchMap, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import { ForwarderActions } from './forwarder.actions';
import { DealerForwarderService } from '../../api-services/dealer/dealer_forwarder.service';
import { AppActions } from '../app/app.actions';

@Injectable()
export class ForwarderEffects {
  private actions$ = inject(Actions)

  constructor(
    private forwarderService: DealerForwarderService,
  ) { }

  loadForwarders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ForwarderActions.loadForwarders),
      concatMap(() =>
        this.forwarderService.getForwarders().pipe(
          switchMap(data => [
            ForwarderActions.loadForwardersSuccess({ data }),
            AppActions.setLoading({ loading: false })
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  // Effect to handle creating a new forwarder.
  createForwarder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ForwarderActions.createForwarder),
      concatMap((payload) =>
        this.forwarderService.createForwarder(payload.payload).pipe(
          switchMap(data => [
            ForwarderActions.createForwarderSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            ForwarderActions.loadForwarders()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  loadForwarderDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ForwarderActions.loadForwarderDetails),
      concatMap((payload) =>
        this.forwarderService.getForwarderById(payload.id).pipe(
          switchMap(data => [
            ForwarderActions.loadForwarderDetailsSuccess({ data }),
            AppActions.setLoading({ loading: false })
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  deleteForwarder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ForwarderActions.deleteForwarder),
      concatMap((payload) =>
        this.forwarderService.deleteForwarder(payload.id).pipe(
          switchMap(data => [
            ForwarderActions.deleteForwarderSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            ForwarderActions.loadForwarders()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

  updateForwarder$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ForwarderActions.updateForwarder),
      concatMap((payload) =>
        this.forwarderService.updateForwarder(payload.payload).pipe(
          switchMap(data => [
            ForwarderActions.updateForwarderSuccess({ data }),
            AppActions.setLoading({ loading: false }),
            ForwarderActions.loadForwarders()
          ]),
          catchError(error => of(AppActions.setError({ error }))),
          startWith(AppActions.setLoading({ loading: true })),
        )
      )
    );
  });

}